import { ApiPermission } from '@allbin/mobilix-api-client';

// Mirrors the AllAuth role provisioning
// (../mobilix-api/allauth_mobilix_roles.json, AUTH_PROVISIONING_RUNBOOK.md
// Step 4). StubAllAuthProvider reuses the admin set.

export const TestUserWorkorderContractorUserPermissions: ApiPermission[] = [
  'contractors:read',
  'entities:read',
  'entities:update',
  'error-reports:create',
  'police-reports:create',
  'role:contractor-agent',
  'workorders:create',
  'workorders:execute',
  'workorders:read',
  'workorders:update',
];

export const TestUserWorkorderContractorAdminPermissions: ApiPermission[] = [
  'checkin-plan:create',
  'checkin-plan:delete',
  'contractors:read',
  'entities:read',
  'entities:update',
  'error-reports:create',
  'instructions:read',
  'police-reports:create',
  'recurring-workorder-plans:create',
  'recurring-workorder-plans:delete',
  'recurring-workorder-plans:read',
  'role:contractor-admin',
  'workorders:create',
  'workorders:execute',
  'workorders:read',
  'workorders:update',
];

export const TestUserWorkorderAdminPermissions: ApiPermission[] = [
  'checkin-plan:create',
  'checkin-plan:delete',
  'contractors:create',
  'contractors:delete',
  'contractors:read',
  'contractors:update',
  'entities:create',
  'entities:delete',
  'entities:read',
  'entities:update',
  'entity-types:create',
  'error-reports:create',
  'instructions:create',
  'instructions:delete',
  'instructions:read',
  'instructions:update',
  'police-reports:create',
  'recurring-workorder-plans:create',
  'recurring-workorder-plans:delete',
  'recurring-workorder-plans:read',
  'role:admin',
  'tags:create',
  'tags:delete',
  'tags:update',
  'workorders:approve',
  'workorders:cancel',
  'workorders:create',
  'workorders:delete',
  'workorders:execute',
  'workorders:read',
  'workorders:update',
];
